import React from 'react';
import './WarningFooter.css';

const WarningFooter = ({ title, content }) => {
  return (
    <div className="warning-footer-container">
      <div className="warning-icon-container">
        <div className="warning-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
            <path d="M33.3086 46.1211C33.3086 47.5363 32.1613 48.6836 30.7461 48.6836C29.3309 48.6836 28.1836 47.5363 28.1836 46.1211C28.1836 44.7059 29.3309 43.5586 30.7461 43.5586C32.1613 43.5586 33.3086 44.7059 33.3086 46.1211Z" fill="#CC3E3E"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M30.7539 5.12109C31.6845 5.12109 32.542 5.62563 32.9939 6.43913L58.6189 52.5641C59.0599 53.3578 59.0479 54.3256 58.5875 55.1081C58.127 55.8906 57.2869 56.3711 56.3789 56.3711H5.12891C4.22096 56.3711 3.38081 55.8906 2.92036 55.1081C2.45992 54.3256 2.44794 53.3578 2.88888 52.5641L28.5139 6.43913C28.9658 5.62563 29.8233 5.12109 30.7539 5.12109ZM9.48391 51.2461H52.0239L30.7539 12.9601L9.48391 51.2461ZM30.7539 23.0586C32.1691 23.0586 33.3164 24.2059 33.3164 25.6211V35.8711C33.3164 37.2863 32.1691 38.4336 30.7539 38.4336C29.3387 38.4336 28.1914 37.2863 28.1914 35.8711V25.6211C28.1914 24.2059 29.3387 23.0586 30.7539 23.0586Z" fill="#CC3E3E"></path>
          </svg>
        </div>
      </div>
      <div className="warning-content">
        <div className="warning-title">
          <p>{title}</p>
        </div>
        <div className="warning-text" >
            <p dangerouslySetInnerHTML={{ __html: content }}>
            </p>
        </div>
      </div>
    </div>
  );
};

export default WarningFooter;
